/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { SmartLinkSize } from '../../../../../../constants';
import { getIconSizeStyles } from '../../../utils';
var getIconWidth = function getIconWidth(size) {
  switch (size) {
    case SmartLinkSize.XLarge:
    case SmartLinkSize.Large:
      return '1.5rem';
    case SmartLinkSize.Medium:
    case SmartLinkSize.Small:
    default:
      return '1rem';
  }
};
var getIconStyles = function getIconStyles(isDisabled) {
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)"
  });
};
var stackItemIconSizeStyles = getIconSizeStyles('20px');
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var stackItemIconStyles = css(stackItemIconSizeStyles, {
  display: 'inline-block',
  lineHeight: 0,
  padding: "var(--ds-space-025, 2px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  'span,svg,img': {
    lineHeight: 0
  }
});
var ActionIcon = function ActionIcon(_ref) {
  var size = _ref.size,
    testId = _ref.testId,
    icon = _ref.icon,
    isDisabled = _ref.isDisabled,
    asStackItemIcon = _ref.asStackItemIcon;
  return jsx("span", {
    css: [
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    getIconStyles(isDisabled),
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    asStackItemIcon ? stackItemIconStyles : getIconSizeStyles(getIconWidth(size))],
    "data-testid": "".concat(testId, "-icon")
  }, icon);
};
export default ActionIcon;